/* eslint-disable */
import React, { useEffect, useState, useContext} from 'react';
import MagnifyingGlass from '../../../Assets/images/svg/dar_magnifying.svg';
import styles from './cloudCost.module.scss';
import DataGridComponent from '../../../Components/DataGrid/dataGrid';
import { TextField} from '@mui/material';
import EditIcon from '../../../Assets/images/svg/dar_pencil.svg';
import ButtonComponent from '../../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import { formatCurrency} from '../costMasterUtils';
import { AuthContext } from '../../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../../Constants/modules';

import {
  CLOUD_COST,
  CLOUD_COST_FIELD,
  CLOUD_COST_HEADER,
  SAVE_SUCCESS,
  UPDATE_SUCCESS,
  OOPS_TRY_AGAIN
} from '../../../Constants/strings';
import { saveCloudCost,getCloudCost,getCloudCostDetails,updateCloudCost } from '../../../Api/request/costMaster';
import UseAxios from '../../../Api/http/http';
import { useSnackbar } from '../../../Components/Snackbar/snackBarProvider';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
import { v4 as uuidv4 } from 'uuid'

const TableView = () => {
  const [rows, setRows] = useState([]);
  const [isMobileView, setIsMobileView] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [originalRows, setOriginalRows] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [environments, setEnvironments] = useState([]);
  const [units, setUnits] = useState([]);
   const [operationType, setOperationType] = useState('insert');
   const { snackbarOpen } = useSnackbar();
   const { userProfile } = useContext(AuthContext);

   const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.MASTER_COST_MASTER] || []
    : [];

    const hasAccess = (action) => permission.includes(action);

  useEffect(() => {
    checkMobileView();
    fetchDropdownData();
    fetchCloudCostDetails();
    window.addEventListener('resize', checkMobileView);
    return () => {
      window.removeEventListener('resize', checkMobileView);
    };
  }, []);

  const fetchDropdownData = async () => {
    try {
      const response = await UseAxios(getCloudCost());
      const { currencies, environments, units } = response.data.data;
      setCurrencies(currencies);
      setEnvironments(environments);
      setUnits(units);
    } catch (error) {
      console.error('Error fetching dropdown data:', error.message || error);
    }
  };

  const fetchCloudCostDetails = async () => {
    try {
      const response = await UseAxios(getCloudCostDetails());
      const transformedData = response?.data?.data?.data?.map((item, index) => ({
        id: item.id,
        srNo: index + 1,
        environment: item.environment,
        unit: item.unit,
        cost: item.cost,
        currency: item.currency,
        remark: item.remark,
        isEditing: false, 
      }));
  
      setRows(transformedData);
    } catch (error) {
      console.error('Error fetching cloud cost details:', error.message || error);
    }
  };

  const handleSearch = (event) => {
    setSearchText(event.target.value.toLowerCase());
  };

  const checkMobileView = () => {
    setIsMobileView(window.innerWidth <= 1100);
  };

  const getFieldIdValue = (field, value) => {
    switch (field) {
      case 'environment':
        return environments.find((env) => env.name === value)?.id || null;
      case 'unit':
        return units.find((unit) => unit.name === value)?.id || null;
      case 'currency':
        return currencies.find((currency) => currency.name === value)?.id || null;
      default:
        return null;
    }
  };

  const handleChange = (e, id, field) => {
    const value = e.target.value?.name || e.target.value;
    
    setRows((prevRows) =>
      prevRows.map((row) => {
        if (row.id === id) {
          const newValue = field === 'currency' && !value ? 'INR' : value; 
          const fieldIdValue = getFieldIdValue(field, newValue);
  
          return {
            ...row,
            [field]: newValue,
            [`${field}Id`]: fieldIdValue, 
          };
        }
        return row;
      })
    );
  };
  
  
  const saveRow = async (rowToSave, operationType) => {
    const id = rowToSave.id;

    const payload = {
      environment: rowToSave.environmentId,
      unit: rowToSave.unitId,
      cost: rowToSave.cost,
      currency: rowToSave.currencyId,
      remark: rowToSave.remark,
    };
    if (operationType === 'insert') {
      try {
        await UseAxios(saveCloudCost(payload));
        snackbarOpen(SAVE_SUCCESS, "success");

      } catch (error) {
        console.error('Error saving row:', error.message || error);
      }
    }
    else if (operationType === 'update') {
      try {
        payload.id = id;
        await UseAxios(updateCloudCost(payload));
        snackbarOpen(UPDATE_SUCCESS, "success");

      } catch (error) {
        snackbarOpen(OOPS_TRY_AGAIN, "error");
        console.error('Error updating row:', error.message || error);
      }
    }
    
    setRows((prevRows) =>
      prevRows.map((row) =>
        row.id === rowToSave.id ? { ...row, isEditing: false } : row
      )
    );
    
    await fetchCloudCostDetails();

    setOriginalRows((prev) => {
      const rest = { ...prev };
      delete rest[rowToSave.id];
      return rest;
    });
  }

  const handleSave = (id) => {
    const rowToSave = rows.find((row) => row.id === id);
    saveRow(rowToSave, operationType);
  };
  

  const handleCancel = (id) => {
    setRows((prevRows) => {
      const updatedRows = prevRows
        .filter((row) => {
          const isUnsavedNewRow = !originalRows[id];
          return row.id !== id || !isUnsavedNewRow;
        })
        .map((row) =>
          row.id === id && originalRows[id]
            ? { ...originalRows[id], isEditing: false }
            : row
        );
      return updatedRows.map((row, index) => ({
        ...row,
        srNo: index + 1,
      }));
  });
  
    setOriginalRows((prev) => {
      const rest = { ...prev };
      delete rest[id];
      return rest;
    });
  };
  

  const filteredRows = searchText
    ? rows.filter((row) =>
        Object.values(row).some((value) =>
          (value ? value.toString() : '').toLowerCase().includes(searchText)
        )
      )
    : rows;
    const handleEdit = (id) => {
      setOperationType('update');
      setOriginalRows((prev) => ({
        ...prev,
        [id]: rows.find((row) => row.id === id),
      }));
      setRows((prevRows) =>
        prevRows.map((row) => (row.id === id ? { ...row, isEditing: true } : row))
      );
    };
    
  const handleAddRow = () => {
    const newRow = {
      id: uuidv4(),
      srNo: rows.length + 1,
      environment: '',
      unit: '',
      cost: '',
      currency: 'INR',
      currencyId: 1,
       remark: '',
      isEditing: true,
    };
    const updatedRows = [newRow, ...rows].map((row, index) => ({
      ...row,
      srNo: index + 1,
    }));
    setRows(updatedRows);
    setOperationType('insert');
  };

  const getSelectedData = (name, options) => {
    return options.find(option => option.name === name) || null;
  };  

  const newCloudRow = {
    environment: '',
    unit: '',
    cost: '',
  };

  const isRowUnchanged = (row) => {
    return Object.keys(newCloudRow).some((key) => row[key] === newCloudRow[key]);
  };

  const columns = [
    {
      field: CLOUD_COST_FIELD.SR_NO,
      headerName: CLOUD_COST_HEADER.SR_NO,
      minWidth:160,
      flex: !isMobileView ? 0.08 : undefined,
      sortable: false,
      disableColumnMenu: true,
    
    },
    {
      field: CLOUD_COST_FIELD.ENVIRONMENT,
      headerName: CLOUD_COST_HEADER.ENVIRONMENT,
      minWidth: 190,
      flex: !isMobileView ? 0.15 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({row}) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={environments}
              onChange={(e) => handleChange(e, row.id, 'environment')}
              value={getSelectedData(row.environment, environments)}
              dropdownCss={styles['text-box-css']}
            /> 
          </div>
        ) : (
          <label className="saved-value">{row.environment}</label>
        ),
    },
    {
      field: CLOUD_COST_FIELD.UNIT,
      headerName: CLOUD_COST_HEADER.UNIT,
      width: 170,
      minWidth: 155,
      flex: !isMobileView ? 0.12 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({row}) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={units}
              onChange={(e) => handleChange(e, row.id, 'unit')}
              value={getSelectedData(row.unit, units)}
              dropdownCss={styles['text-box-css']}
            /> 
          </div>
        ) : (
          <label className="saved-value">{row.unit}</label>
        ),
    },
    {
      field: CLOUD_COST_FIELD.COST_AND_CURRENCY,
      headerName: CLOUD_COST_HEADER.COST_AND_CURRENCY,
      minWidth: 215,
      flex: !isMobileView ? 0.1 : undefined,
      sortable: false,
      disableColumnMenu: true,
      headerClassName: styles["cloudCost-header"],
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', alignItems: 'center' }} className={styles['number-input-div']}>
            <SearchDropdown
              searchBox={false}
              placeholder='Select'
              options={currencies}
              onChange={(e) => handleChange(e, row.id, 'currency')}
              value={getSelectedData(row.currency, currencies)}
              dropdownCss={styles['currency-select']}
            />
            <TextField
              defaultValue={row.cost}
              onChange={(e) => handleChange(e, row.id, 'cost')}
              onKeyDown={(e) => e.stopPropagation()}
              className={styles['number-input']}
              variant="outlined"
              size="small"
              inputProps={{
                inputMode: 'decimal',
                pattern: '[0-9]*[.]?[0-9]*',
              }}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9.]/g, '');
                const parts = e.target.value.split('.');
                if (parts.length > 2) {
                  e.target.value = parts[0] + '.' + parts.slice(1).join('');
                }
              }}
            />
          </div>
        ) : (
          <label className={styles["cloudCost-cell"]}>
            {formatCurrency(row.cost, row.currency)}
          </label>
        ),
    },
    {
      field: CLOUD_COST_FIELD.REMARKS,
      headerName: CLOUD_COST_HEADER.REMARKS,
      minWidth: 220,
      flex: !isMobileView ? 0.15 : undefined,
      sortable: false,
      disableColumnMenu: true,
      renderCell: ({ row }) =>
        row.isEditing ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <TextField
              defaultValue={row.remark}
              onChange={(e) => handleChange(e, row.id, "remark")}
              onKeyDown={(e) => e.stopPropagation()}
              className={`${styles['text-box-css']} ${styles['remarks']}`}
              variant="outlined"
              size="small"
            />
          </div>
        ) : (
          <label >
            {row.remark && row.remark.trim() !== ''
            ? row.remark
            : '-'}
            </label>
        ),
    }
    
    
  ];
  
  

  const sortFilterColumns = columns.map((column) => column.field);



  

  const cloudCostColumns = [
    ...columns,
    {
      headerClassName: !isMobileView ? '' : `${styles['action-column']} ${styles['tableView-action-cellWidth']}`,
      cellClassName: !isMobileView ? '' : `${styles['action-cell']} ${styles['tableView-action-cellWidth']}`,
      flex: 0.01,
      minWidth: 75,
      renderCell: ({row}) => (
         <div style={{ marginTop: row.isEditing ? '4px' : '0', justifySelf:'center'}}>
        {!row?.isEditing ?(
          <button
            className="role-action-edit-icon"
            aria-label="Edit"
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: hasAccess('update') ? 'pointer' : 'not-allowed',
              opacity: hasAccess('update') ? 1 : 0.5, 
            }}
            onClick={() => handleEdit(row.id)}
            disabled={!hasAccess('update')}
          >
            <img src={EditIcon} alt="Edit" />
          </button>
          ) : (
            <div className={styles['save-and-cancel-button-main']} style={{ paddingTop: '0px'}}>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-tick-placing']}
                style={{
                  backgroundColor: isRowUnchanged(row) ? '#a69df1' : '#6B5CE8', 
                  color: '#ffff',
                }}
                onClick={() => handleSave(row.id)}
                disabled={isRowUnchanged(row)}
              >✔</button>
              <button
                className={styles['save-and-cancel-button'] + ' ' + styles['save-button-cross-placing']}
                style={{
                  backgroundColor: 'transparent',
                  color: '#6B5CE8',
                  border:'1px solid #6B5CE8'
                }}
                onClick={() => handleCancel(row.id)}
              >X</button>
            </div>
          )}
        </div>
      ),
      sortable: false,
      disableColumnMenu: true,
    },
  ];

  const rowHeightCondition = (params) => 
    rows.find((row) => row.id === params.id)?.isEditing ? 104 : 52;
  
  return (
    <div className="users-manage-outer-layer">
      <div className="users-manage">
        <div
          className={`${styles['tableView-search-and-buttons']} ${styles['tableView-headerSection-flex']} ${styles['filteredRows-tableView']} ${styles['tableView-margin']}`}
          style={{ padding: '8px 12px' }}
        >
          <div className={styles['tableView-headerSection-main']}>
            <div
              className={`${styles['tableView-search']} ${styles['tableView-headerSection-mainSearchInput']}`}
            >
              <div className={styles['tableView-headerSection-search']}>
                <img src={MagnifyingGlass} alt="Search" />
                <input
                  id="tableView-search-input"
                  type="text"
                  placeholder="Search..."
                  onChange={handleSearch}
                  className={styles['tableView-headerSection-searchInput']}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className={`${styles['tableView-data-grid-container']} ${styles['filteredRows-tableView']}}`}
        >
          <div className={styles['cost-title-container']}>
            <div className={styles['staffing-cost-button']}>
              <h2>{CLOUD_COST}</h2>
              <div className={styles['tableView-buttons']}>
          
            <div className={styles['add-button-style']}>
            <ButtonComponent
              variant="contained"
              label="Add"
              onClick={handleAddRow}
              startIcon={<AddIcon />}
              disabled={!hasAccess('create')}
            />
            </div>
          </div>
           
            </div>

            <DataGridComponent
              dataRows={filteredRows}
              dataColumns={cloudCostColumns}
              isDealTransition={true}
              isFilteredRows={filteredRows}
              sortFilterColumns={sortFilterColumns}
              pageSize={10}
              onRowSelectionChange={() => {}}
             rowHeightCondition={rowHeightCondition}
            />
          </div>
        </div>
      </div>  
    </div>
  );
};

export default TableView;
